export const percentage = (partialValue: number, totalValue: number) => {
  if (partialValue <= 0 || totalValue <= 0) {
    return 0;
  }
  return Math.round((100 * partialValue) / totalValue);
};
